import React, { useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { Sphere, Html } from '@react-three/drei'
import * as THREE from 'three';
import * as tf from '@tensorflow/tfjs';
// import chebyshevLP from './LP';
import itertools from './itertools';


function SignVector(props) {

    const [occlude] = useState(false)
    // <Html {...props} center>
    return (
        <Html {...props} occlude={occlude} center>
          <span style={{display: 'flex'}}>
            { props.text.map((c, i) => <span key={i} className="signchar" style={{color: props.colors[i], opacity: props.opacity}}>{c}</span>) }
          </span>
        {/* <span>{ props.text.map((c, i) => <span>{c}</span>) } </span> */}
        </Html>
    );
}

export default SignVector;
